var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"lay__edit"},[_c('TopBar'),_c('div',{staticClass:"layout__main"},[_c('LeftMenu'),_c('div',{staticClass:"page__scroll"},[_c('div',{staticClass:"page__con hs"},[_c('router-view')],1)])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }